import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function aiOutreachAgentsListRequest(urlParams = {}) {
  let url = urls.aiOutreachAgentsList;

  if (urlParams.page) {
    url = urls.aiOutreachAgentsListPsf;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
  });
}

export async function aiOutreachAgentsItemRequest(urlParams = {}) {
  const url = urls.aiOutreachAgentsItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function testPrompt(projectId, companyId, prompt, urlsValues, email, linkedin_url) {
  return request({
    method: 'POST',
    url: urls.aiOutreachAgentsTestPrompt,
    data: {
      company_id: companyId,
      prompt,
      page_urls: urlsValues,
      email,
      linkedin_url,
    },
    urlParams: { projectId },
    headers: getHeaders(),
  });
}

export async function aiOutreachAgentsCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.aiOutreachAgentsCreate,
    data,
    urlParams,
    headers: getHeaders(),
  });
}

export async function aiOutreachAgentsUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.aiOutreachAgentsUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function aiOutreachAgentsRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.aiOutreachAgentsRemove,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/aiOutreachAgents.js